import SideBar from "../../components/sideBar";
import BodyManage from "./components/bodyManage";
import HeaderManage from "./components/headerManage";
import './index.css';

export default function ManageLayout({activeIndex, breadcrumbs, children}) {
  return (
    <>
      <div className="main">
        <div className = 'row'>
          <div className = 'col-lg-1 col-md-0 min-vh-100 p-0 sidebar'>
            <div className="header_merge_manage"></div>
            <div className="sidebar_fixed layout_manage">
              <SideBar activeIndex={activeIndex}></SideBar>
            </div>
          </div>
          <div className = 'col-lg-11 p-0 col-12'>
            <HeaderManage activeIndex={activeIndex} breadcrumbs={breadcrumbs}></HeaderManage>
            <BodyManage children = {children}></BodyManage>
          </div>
        </div>
      </div>
    </>
  )
}